import React from 'react';
import { Trans, useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Button } from '@hz-design-system/web-ui';

import BundleSellingPoint, { variants } from './BundleSellingPoint';
import Classes from './BundleSellingPoints.module.scss';

const BundleSellingPoints = ({
  onCtaClick,
  isPending,
}: {
  onCtaClick: (...args: any[]) => void;
  isPending: boolean;
}) => {
  const i18n = useI18nContext();

  return (
    <div className={Classes.root}>
      <h2 className={Classes.sectionTitle}>{i18n.t('landingFreeBundle.sellingPoints.title')}</h2>
      <div className={Classes.parentWrap}>
        <div className={Classes.itemWrap}>
          <BundleSellingPoint
            variant={variants.profile}
            description={i18n.t('landingFreeBundle.sellingPoints.point1')}
          />
        </div>
        <div className={Classes.itemWrap}>
          <BundleSellingPoint variant={variants.shop} description={i18n.t('landingFreeBundle.sellingPoints.point2')} />
        </div>
        <div className={Classes.itemWrap}>
          <BundleSellingPoint
            variant={variants.listings}
            description={i18n.t('landingFreeBundle.sellingPoints.point3')}
          />
        </div>
      </div>
      <div className={`${Classes.ctaAndDisclaimer} hz-FreeBundle-cta`}>
        <p>
          <Button.Primary onClick={onCtaClick} disabled={isPending}>
            {i18n.t('landingFreeBundle.buttons.cta')}
          </Button.Primary>
        </p>
        <Trans i18nKey="landingFreeBundle.disclaimers.sellerProfile" />
      </div>
    </div>
  );
};

export default BundleSellingPoints;
